module.exports = __webpack_public_path__ + "img/emulator.1310d1bf.jpg";